import { useState, useEffect, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
  addSkinconcern,
  getSkinconcerns,
  getSkinconcern,
  editSkinconcern,
  deleteSkinconcern,
  getAllSkinconcerns,
} from '../../store/actions/skinconcern_action';
import _debounce from 'lodash/debounce';

// Get All Data
export const useAllSkinconcerns = () => {
  const dispatch = useDispatch();
  const data = useSelector((state) => state.skinconcern);
  const [pageNumber, setPageNumber] = useState(1);
  const [deleteEntry, setDeleteEntry] = useState(null);

  useEffect(() => {
    if (deleteEntry) {
      dispatch(deleteSkinconcern(deleteEntry));
    }
    allQuery();
  }, [deleteEntry, pageNumber, window.location.search]);
  const allQuery = useCallback(
    _debounce(() => {
      dispatch(
        getSkinconcerns({
          pageNumber,
        })
      );
    }, 1000),
    []
  );

  useEffect(() => {
    setPageNumber(1);
  }, [window.location.search]);

  const deleteBtnClicked = async (id) => {
    setDeleteEntry(id);
  };

  return [data, setPageNumber, deleteBtnClicked];
};

// Get Single Data
export const useSingleSkinconcern = (id) => {
  const dispatch = useDispatch();
  const data = useSelector((state) => state.skinconcern);
  useEffect(() => {
    dispatch(getSkinconcern(id));
  }, [id]);
  return [data];
};
// Add Data
export const useCreateSkinconcern = () => {
  const dispatch = useDispatch();
  const data = useSelector((state) => state.skinconcern);
  const addData = async (data) => {
    await dispatch(addSkinconcern(data));
  };
  return [data, addData];
};
export const useUpdateSkinconcern = () => {
  const dispatch = useDispatch();
  const updateData = async (id, data) => {
    console.log('datatatatatatat', data);
    await dispatch(editSkinconcern(id, data));
  };
  return [updateData];
};

export const useSelectAllSkinconcern = () => {
  const dispatch = useDispatch();
  const [term, setTerm] = useState('');
  const [value, setValue] = useState('');
  const data = useSelector((state) => state.skinconcern);
  useEffect(() => {
    dispatch(getAllSkinconcerns({ term, value }));
  }, [term, value]);
  return [data, setTerm, setValue];
};

export const useGetDropdownOptions = () => {
  const [dropdownOptions, setDropdownOptions] = useState({});
  const loadOptions = async (inputValue, callback, field) => {
  };

  return [dropdownOptions, loadOptions];
};
